<template>
  <b-card
    no-body
    class="mb-0"
  >
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>{{ $t('Show') }}</label>
          <v-select
            v-model="perPageLocal"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
          />
          <label>{{ $t('entries') }}</label>
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end" />
        </b-col>
      </b-row>
    </div>

    <b-table
      ref="refListTable"
      class="table-responsive table-nowrap"
      :items="itemsData"
      :fields="tableColumns"
      responsive="sm"
      show-empty
      empty-text="Không tìm thấy kết quả"
    >
      <!-- Column: Name -->
      <template #cell(name)="row">
        <span @click="clickEdit(row.item.id)">{{ resolveNameLevelText(row.item.name, row.item.level) }}</span>
      </template>

      <!-- Column: Parent -->
      <template #cell(parent_id)="row">
        {{ row.item.parent ? row.item.parent.name : '' }}
      </template>

      <!-- Column: is_director -->
      <template #cell(is_director)="row">
        <feather-icon
          v-if="row.item.is_director"
          icon="CheckIcon"
        />
        <span v-else>-</span>
      </template>

      <!-- Column: Actions -->
      <template
        #cell(actions)="row"
        class="text-right"
      >
        <!-- <b-button
          v-if="$can('department.show', 'Department')"
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          v-b-tooltip
          class="btn-icon "
          variant="outline-primary"
          title="Danh sách người dùng"
          size="sm"
          :to="{ name: 'departments-user', params: { id: row.item.id } }"
        >
          <feather-icon icon="UsersIcon" />
        </b-button> -->
        <b-button
          v-if="$can('department.update', 'Department')"
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          v-b-tooltip
          class="btn-icon ml-1"
          variant="outline-primary"
          :to="{ name: 'departments-edit', params: { id: row.item.id } }"
          title="Sửa"
          size="sm"
        >
          <feather-icon icon="EditIcon" />
        </b-button>
        <b-button
          v-if="$can('department.destroy', 'Department')"
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          v-b-tooltip
          class="btn-icon ml-1"
          variant="outline-danger"
          title="Xóa"
          size="sm"
          @click="confirmDelete(row.item.id)"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>
      </template>

    </b-table>

    <div class="mx-2 mb-2">
      <b-row>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of })
          }}</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPageLocal"
            :total-rows="totalEntries"
            :per-page="perPageLocal"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTable,
  BPagination, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, computed } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import useDepartments from './useDepartments'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BPagination,
    vSelect,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    itemsData: {
      type: Array,
      default: () => [],
    },
    totalEntries: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 0,
    },
    perPage: {
      type: Number,
      default: 0,
    },
  },
  setup(props, context) {
    const perPageLocal = computed({
      get() { return props.perPage },
      set(val) {
        context.emit('update:perPage', val)
      },
    });
    const currentPageLocal = computed({
      get() { return props.currentPage },
      set(val) {
        context.emit('update:currentPage', val)
      },
    });
    const {
      tableColumns,
      dataMeta,
      perPageOptions,
      isSortDirDesc,
      refListTable,

      // UI
      resolveUserDepartmentVariant,
      resolveUserDepartmentIcon,
      resolveUserStatusVariant,
      resolveUserStatusText,
      resolveTypeText,
      resolveNameLevelText,
      confirmDelete,
    } = useDepartments()

    return {
      // Sidebar

      tableColumns,
      dataMeta,
      perPageOptions,
      isSortDirDesc,
      refListTable,

      // Filter
      avatarText,

      // UI
      resolveUserDepartmentVariant,
      resolveUserDepartmentIcon,
      resolveUserStatusVariant,
      resolveUserStatusText,
      resolveTypeText,
      resolveNameLevelText,
      confirmDelete,
      perPageLocal,
      currentPageLocal,
    }
  },
  methods: {

  },
}
</script>

<style lang="scss" scoped></style>
